<template>
    <div class="box">
        <Titlebar
                :title="'激活货柜'"/>

        <video id="video" class="qrcode-video"/>

        <div class="note">
            2. 请再扫描货柜二维码
        </div>
        <video-device-error placeholder="输入货柜码" v-model="visible" prefix="https://consumer.goldbox.vip/m/"
                            @submit="onDecode"/>
    </div>
</template>

<script>
    import Titlebar from "./Titlebar.vue"
    import videoDeviceError from "./videoDeviceError"

    import {isCupboardNumber} from "../util/utils.js"
    import message from "ant-design-vue/lib/message";
    import {scanQrCode} from '../util/qrcode.js';

    export default {
        name: 'BindScanCupboard',
        data() {
            return {
                visible: false
            }
        },
        props: {},
        components: {
            Titlebar,
            videoDeviceError
        },
        mounted() {
            scanQrCode("video", this.onDecode, () => {
                this.visible = true;
            })
        },
        methods: {
            onDecode(cupboardUrl) {
                console.log(cupboardUrl)
                if (isCupboardNumber(cupboardUrl)) {
                    var urls = cupboardUrl.split("/")
                    var cupboardNumber = urls[urls.length - 1]

                    const url = process.env.VUE_APP_API_SERVER + '/machine/' + cupboardNumber + "/pair"
                    var accessToken = localStorage.getItem('accessToken')

                    var data = {
                        BoxSerialNum: sessionStorage.getItem("bindDeviceNumber")
                        // BoxSerialNum:"e38d9835a1386b5c6ecd29c27ec1fa07"
                    };

                    fetch(url, {
                        method: 'POST',
                        body: JSON.stringify(data),
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            'Access-Token': accessToken
                        })
                    }).then(res => {
                        if (!res.ok) {
                            throw res;
                        }
                        return res.json();
                    }).catch(error => {
                        message.error("扫描货柜二维码失败: " + error)
                    }).then(response => {
                        console.log(response)

                        if (response.Status == 0) {
                            sessionStorage.setItem("bindCupboardNumber", cupboardNumber)
                            sessionStorage.setItem("bindBoxTag", response.Tag)

                            this.$router.push("/bindok")
                        } else if (response.Status == 2) {
                            message.error("激活请求参数错误")
                        } else if (response.Status == 4) {
                            message.error("激活请求服务器内部错误")
                        } else if (response.Status == 6) {
                            message.error("货柜已经激活，请勿重复激活")
                        }
                    });
                } else {
                    message.error("货柜码有误")
                }
            }
        }
    }
</script>

<style scoped>
    .note {
        margin-top: 20px;
        font-size: 20px;
        color: #666;
    }

    .box {
        width: 100%;
        height: 100%;
    }

    .qrcode-video {
        width: 100%;
        height: 50%;
        background-color: black;
    }
</style>
